<template>
  <a-locale-provider :locale="zh_CN">
    <div id="app">
      <div v-if="loading" class="loading"> 页面载入中...</div>
      <router-view v-else/>
    </div>
  </a-locale-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import { initMenuRoutes } from '@/router/mixin';
import Cookies from 'js-cookie';
import eBase from '@/base/eBase.js';

export default {
  name: 'AppPage',

  data() {
    return {
      zh_CN,
      loading: false,
    };
  },
  methods: {
    clearStorage() {
      sessionStorage.clear();
    },
  },
  created() {

    eBase.debug('[AppPage.vue][created][enter][==============================]');

    if (~window.location.pathname.indexOf('login') || ~window.location.hash.indexOf('login')) return;

    if(!sessionStorage.getItem('login_token')) {
      eBase.debug('[AppPage.vue][created][没有login_token，跳到登录页面]');
      this.clearStorage();
      this.$router.push('/login');
      return;
    }

    if(Cookies.get('token')) {
      eBase.debug('[AppPage.vue][created][拿到cookies中的token赋给sessionStorage.login_token]');
      sessionStorage.login_token = Cookies.get('token');
    }

    (async () => {
      this.loading = true;
      const res = await initMenuRoutes((res) => {
        this.$message.error(res.data.msg);
      });
      eBase.debug('[AppPage.vue][created][初始化菜单]');
      this.$router.addRoutes(res);
      this.loading = false;
    })();
  },
};
</script>

<style lang="less" scoped>
#app {
  .loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/AppPage.vue